import { Page, Card, FormLayout, TextField, Button, Select } from "@shopify/polaris";
import { useState } from "react";

export default function RentalTester({ onNavigate }) {
  const [variantId, setVariantId] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [quantity, setQuantity] = useState("1");
  const [rateType, setRateType] = useState("daily");
  const [loading, setLoading] = useState(false);

  const handleTest = async () => {
    setLoading(true);

    try {
      const res = await fetch("/api/rentals", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include", // 🔥 REQUIRED for Shopify session
        body: JSON.stringify({
          variantId,
          startDate,
          endDate,
          quantity: Number(quantity),
          rateType,
        }),
      });

      const data = await res.json();
      console.log("Rental API Response:", data);

      if (!res.ok) {
        alert(data.message || "Rental failed");
      } else {
        alert("✅ Rental created successfully");
      }

    } catch (err) {
      console.error(err);
      alert("❌ API Error");
    }

    setLoading(false);
  };

  return (
    <Page
      title="Rental Tester"
      backAction={{ content: "Dashboard", onAction: () => onNavigate("dashboard") }}
    >
      <Card sectioned>
        <FormLayout>
          <TextField label="Variant ID" value={variantId} onChange={setVariantId} />
          <TextField label="Start Date" type="date" value={startDate} onChange={setStartDate} />
          <TextField label="End Date" type="date" value={endDate} onChange={setEndDate} />
          <TextField label="Quantity" type="number" value={quantity} onChange={setQuantity} />

          <Select
            label="Rate Type"
            options={[
              { label: "Daily", value: "daily" },
              { label: "Weekly", value: "weekly" },
              { label: "Monthly", value: "monthly" },
            ]}
            value={rateType}
            onChange={setRateType}
          />

          <Button primary loading={loading} onClick={handleTest}>
            Test Rental API
          </Button>
        </FormLayout>
      </Card>
    </Page>
  );
}
